<component-modal [showFooter]="false">
  <ng-container title>
    <div class="d-flex align-items-center justify-content-between w-100">
      <span>Share role</span>
      <button type="button" class="btn btn-sm btn-link text-decoration-none d-flex align-items-center gap-2" (click)="copyLink()">
        <lucide-icon [img]="linkCopied() ? checkIcon : linkIcon" size="16"></lucide-icon>
        {{ linkCopied() ? "Link copied" : "Copy link" }}
      </button>
    </div>
  </ng-container>

  <ng-container body>
    <div class="d-flex flex-column gap-3">
      <!-- Form Section -->
      <form class="d-flex flex-column gap-3">
        <!-- Invite Row -->
        <div class="form-group">
          <label class="form-label" for="typeahead-user">Email or username</label>
          <div class="d-flex gap-2">
            <div class="flex-grow-1 position-relative">
              <input
                id="typeahead-user"
                #instance="ngbTypeahead"
                type="text"
                class="form-control form-control-lg"
                [ngModel]="formState().recipient"
                (ngModelChange)="updateRecipient($event)"
                [ngModelOptions]="{ standalone: true }"
                [ngbTypeahead]="searchUsers"
                [inputFormatter]="formatter"
                [resultFormatter]="formatter"
                [selectOnExact]="true"
                (selectItem)="onUserSelected($event)"
                (focus)="focus$.next($any($event).target.value)"
                (click)="click$.next($any($event).target.value)"
                [editable]="true"
                placeholder="user@example.com or username" />
            </div>

            <button
              type="button"
              class="btn btn-primary"
              (click)="shareRole()"
              [disabled]="loading() || (!formState().recipient && !formState().selectedUser)">
              @if (loading()) {
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              } @else {
                Share
              }
            </button>
          </div>
        </div>
      </form>

      <!-- Bottom Toggles -->
      <div class="d-flex flex-column gap-2 mt-2">
        <!-- Share with Organization -->
        @if (user()?.organization) {
          <div class="d-flex align-items-center justify-content-between p-3">
            <div class="d-flex align-items-center gap-3">
              <div
                class="p-2 bg-secondary-subtle d-flex align-items-center justify-content-center rounded"
                style="width: 40px; height: 40px">
                <lucide-icon [img]="usersIcon" size="20" class="text-secondary"></lucide-icon>
              </div>
              <div>
                <div class="fw-semibold text-sm">Share with organization {{ user()?.organization?.name }}</div>
                <div class="small text-muted">
                  {{
                    isOrgShared()
                      ? "New members will automatically receive this role"
                      : "Make available to all organization members"
                  }}
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center gap-2">
              <component-toggle [checked]="isOrgShared()" (checkedChange)="toggleShareWithOrganization()"></component-toggle>
            </div>
          </div>
        }
      </div>
    </div>
  </ng-container>
</component-modal>
